<template>
  <div></div>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import onboardingApi from '../../../../api/OnbordingApi';

const ONBOARDING_STATUS = {
  NEW: 'new',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
};

export default {
  name: 'StateRouter',
  async created() {
    await this.init();
    const { onboardingState } = await onboardingApi.fetchOnboardingState();
    const redirectTo = this.redirectTo(this.onboardingStatus, onboardingState);
    this.$router.replace({ path: redirectTo, query: this.$route.query });
  },
  computed: {
    ...mapState('customerState', ['onboardingStatus']),
  },
  methods: {
    ...mapActions('customerState', ['init']),
    redirectTo(onboardingStatus, onboardingState) {
      if (onboardingState && onboardingStatus !== ONBOARDING_STATUS.COMPLETED) {
        return 'ob';
      }
      if (onboardingStatus === ONBOARDING_STATUS.NEW) {
        return 'onboard';
      }
      return 'home';
    },
  },
};
</script>
